import { format, formatDistanceToNowStrict } from 'date-fns'

import { Maybe } from '@acre/graphql'

import { emptyVal } from '../constants'

export const formatDate = (date: string) => {
  if (date.includes('*')) {
    return date.split('-').reverse().join('/')
  } else {
    return format(new Date(date), 'dd/MM/yyyy')
  }
}

export const formatDateTime = (date: string) => {
  if (date.includes('*')) {
    return formatDate(date)
  }

  const formatString = 'dd/MM/yyyy h:mm aaa'
  let localDate = new Date(date)

  if (localDate.getTimezoneOffset()) {
    localDate = new Date(localDate.valueOf() + localDate.getTimezoneOffset() * 60 * 1000)
  }

  return format(localDate, formatString)
}

export const formatDateWithDash = (date: string) => {
  if (date.includes('*')) {
    return date.split('-').reverse().join('-')
  } else {
    return format(new Date(date), 'dd-MM-yyyy')
  }
}

export const momentToApiDate = (date: Date): string => (date ? format(new Date(date), 'yyyy-MM-dd') : date)

export const documentUploadDate = (date_stored?: Maybe<string>) => {
  return date_stored ? format(new Date(date_stored), 'yyyy/MM/dd HH:mm') : emptyVal
}

export const docStoredTime = (date_stored?: Maybe<string>) => {
  return date_stored ? formatDistanceToNowStrict(new Date(date_stored)) : emptyVal
}

export const fullMonthAndYear = (date: string) => {
  return format(new Date(date), 'MMMM yyyy')
}
